<template>
  <v-container px-1 text-xs-center>
    <v-card>
      <v-card-title>
        ស្វែងរក
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataTable"
        :search="search"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        class="elevation-1"
        @page-count="pageCount = $event"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.dis_name_KH }}</td>
          <td class="text-xs-left">{{ props.item.school_code }}</td>
          <td class="text-xs-left">{{ props.item.sch_name_EN }}</td>
          <td class="text-xs-left">{{ props.item.sch_name_KH }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-row class="px-1">
        <v-col class="py-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: ["dataTable"],
  data() {
    return {
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        {
          text: "District Name",
          align: "left",
          sortable: false,
          value: "dis_name_KH",
        },
        {
          text: "School Code",
          align: "left",
          sortable: false,
          value: "school_code",
        },
        {
          text: "School Name",
          align: "left",
          sortable: false,
          value: "sch_name_EN",
        },
        {
          text: "School Name Khmer",
          align: "left",
          sortable: false,
          value: "sch_name_KH",
        },
      ],
    };
  },
  methods: {},
  computed: {
    /*
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    */
  },
  created() {},
};
</script>

<style scoped>
.questionTitle {
  font-family: "khmer";
  font-size: 18px;
}
.starTitle {
  font-family: "khmer";
  font-size: 20px;
}
.categoryTitle {
  font-family: "khmer";
  font-weight: bold;
  font-size: 20px;
}
.v-list {
  height: 300px;
  overflow-y: auto;
}
</style>
